import { Controller } from 'react-hook-form'

import { FieldType } from 'src/pages/ServiceContacts/types'
import { RenderField } from 'src/features/RenderFieldForContactsUpdateWindow/types'
import { Textarea } from 'src/components/shadcn/textarea'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from 'src/components/shadcn/select'
import { Input } from 'src/components/shadcn/input'

export const renderField = ({
  id,
  label,
  placeholder,
  type,
  validation,
  options,
  control,
}: RenderField) => {
  switch (type) {
    case FieldType.INPUT:
      return (
        <Input
          id={id}
          placeholder={placeholder}
          {...control.register(id, validation)}
        />
      )

    case FieldType.TEXTAREA:
      return (
        <Textarea
          id={id}
          placeholder={placeholder}
          {...control.register(id, validation)}
        />
      )

    case FieldType.SELECT:
      return (
        <Controller
          name={id}
          control={control}
          rules={validation}
          render={({ field }) => (
            <Select value={String(field.value)} onValueChange={field.onChange}>
              <SelectTrigger>
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectLabel>{label}</SelectLabel>
                  {options?.map(({ value, label }) => (
                    <SelectItem key={value} value={value}>
                      {label}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          )}
        />
      )

    default:
      return null
  }
}
